<template>
  <div class="info-block">
    <f-sprite-icon
      v-if="isInteractive"
      v-tooltip.arrow.onclick="tooltipText"
      class="info-block__icon"
      :icon-link="this.$options.icons.InfoSmall.id"
    />
    <f-sprite-icon
      v-else
      v-tooltip.arrow="tooltipText"
      class="info-block__icon"
      :icon-link="this.$options.icons.InfoSmall.id"
    />
  </div>
</template>

<script>
import InfoSmall from '@images/info-small.multi.svg';

export default {
  name: 'info-block',

  icons: {
    InfoSmall,
  },

  props: {
    tooltipText: {
      type: String,
      required: true,
    },
    isInteractive: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
  .info-block {
    display: inline-block;

    & &__icon {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
</style>